/** Group order (PLAN §2.4): lower first. Top hit and Recent are not providers. */
export const ORDER = Object.freeze({
  people: 30,
  chats: 40,
  messages: 45,
  tasks: 50,
  boards: 60,
  documents: 70,
  requests: 80,
  collections: 90,
  workspaces: 92,
  environments: 94,
  calendar: 100,
  projects: 110,
  teams: 115,
  pages: 120,
  settings: 130,
  commands: 140,
  tabs: 150,
  help: 200,
});
